import './deleteRemarkPopup.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { ConfirmationPopup } from '../../../../../components/confirmation-popup/confirmationpopup'
import { text } from '../../constants'
import { deleteVisitRemark, setDeleteRemarkId } from '../../../../../store/visits/VisitsActions'

export const DeleteRemarkPopup = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const params = new URLSearchParams(window.location.search)
  const visitId = location.state?.visitId || params.get('visitId')

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const deleteRemarkId = useSelector((state) => state.visitsPage.deleteRemarkId)

  if (!deleteRemarkId) {
    return null
  }

  const onDelete = () => {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    dispatch(deleteVisitRemark(visitId, deleteRemarkId))
  }

  const onCancel = () => {
    dispatch(setDeleteRemarkId())
  }

  return (
    // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered
    <ConfirmationPopup
      additionalContainerClass='visit-details-delete-remark-popup'
      title={text.DELETE_VISIT_REMARK}
      primaryBtnAction={onDelete}
      primaryBtnText={text.DELETE}
      secondaryBtnAction={onCancel}
      secondaryBtnText={text.CANCEL}
      msg={text.ARE_YOU_SURE_YOU_WANT_DELETE}
      closeAction={onCancel}
    />
  )
}
